import { render, staticRenderFns } from "./DistrictEdit.vue?vue&type=template&id=5c32deda&scoped=true&lang=pug&"
import script from "./DistrictEdit.vue?vue&type=script&lang=js&"
export * from "./DistrictEdit.vue?vue&type=script&lang=js&"
import style0 from "./DistrictEdit.vue?vue&type=style&index=0&id=5c32deda&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c32deda",
  null
  
)

export default component.exports